<template>
  <div v-if="channellist && channellist.length > 0">
    <template v-for="channel in channellist">
      <v-btn
        :key="`channel_${channel}`"
        depressed
        :outline="value != channel"
        :color="value == channel ? 'primary' : 'grey'"
        @click="onchange(channel)"
        class="ma-0 mr-1 mb-1"
        >{{ $t(channel) }}</v-btn
      >
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {},
    type: {}
  },
  data() {
    return {
      channellist: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this
    vm.channellist.push('all')
    const packages = vm.selectedBot.packages
    if (vm.type != 'comment') {
      if (packages.includes('facebook')) {
        vm.channellist.push('facebook')
      }
      if (packages.includes('line')) {
        vm.channellist.push('line')
      }
      if (packages.includes('instagram')) {
        vm.channellist.push('instagram')
      }
      if (packages.includes('whatsapp')) {
        vm.channellist.push('whatsapp')
      }
      if (packages.includes('google')) {
        vm.channellist.push('google')
      }
    } else {
      if (packages.includes('facebook')) {
        vm.channellist.push('facebook')
      }
      if (packages.includes('instagram')) {
        vm.channellist.push('instagram')
      }
    }
  },
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  methods: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onchange(value) {
      this.$emit('input', value)
      this.$emit('changeChannel', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/SelectChannel.vue